import * as boConstants from "../constants/backOfficeActions";

import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import isEmail from "validator/lib/isEmail";

export const sendFileData = (file, e, showStatusDialog, setStatusMessage) => async (dispatch) => {

  let formDatas = new FormData(e.target);
  let toastId = toast.loading("Please wait. Processing file.");

  try {
    let response = await axios({
      method: "post",
      url: process.env.REACT_APP_BO_UPLOAD_URL,
      data: formDatas,
      headers: {"Content-Type": "multipart/form-data"},
    });

    toast.dismiss(toastId);

    //setStatusMessage("Success for file " + file.name + response.data.message);
    setStatusMessage("File \"" + file.name + "\" uploaded successfully. " + response.data.message);
    showStatusDialog();

    // Now that the file has been uploaded, call the get loads endpoint to refresh the list
    dispatch(getLoads());

  } catch (error) {

    const message =
        (error.response && error.response.data) ||
        error.response ||
        error.message ||
        error.toString();

    toast.dismiss(toastId);
//    toast.error("Failed to load file " + file.name + ".\n" +
//      "Error: " + message, {
//      progress: 0.99,
//    });
    // format the incoming message so that it can be displayed in a toast window nicely
    const formatted = message
        .split(/\r?\n|<br\s*\/?>/i)
        .map((line, i) => <div key={i}>{line}<br /></div>);

    toast.error(
        <div style={{ whiteSpace: "pre-line" }}>
          Failed to load file {file.name}.<br /><br />
          {formatted}
        </div>,
        {
          progress: 0.99,
        }
    );
  }
};

export const sendInCommFileData = (file, e) => async (dispatch) => {

  let formDatas = new FormData(e.target);
  let toastId = toast.loading("Please wait. Processing file.");

  try {
    let response = await axios({
      method: "post",
      url: process.env.REACT_APP_BO_UPLOAD_INCOMM_URL,
      data: formDatas,
      headers: {"Content-Type": "multipart/form-data"},
    });

    //handle success
    toast.dismiss(toastId);
    toast.success("Success for file " + file.name +".\n" +
      response.data.message, {progress: 0.99, style: {whiteSpace: 'pre-line'}});

    // Now that the file has been uploaded, call the get loads endpoint to refresh the list
    dispatch(getInCommLoads());

  } catch (error) {

    const message =
      (error.response && error.response.data) ||
      error.response ||
      error.message ||
      error.toString();

    toast.dismiss(toastId);
    toast.error("Failed to load file " + file.name + ".\n" +
      "Error: " + message, {
      progress: 0.99,
    });
  }
};

export const toggleLoads = (loadsToToggle)=> async (dispatch) => {

  // Convert loadsToToggle to an array of key-value pairs
  // loadsToToggle contains the list of loads that the user has changed
  const loadsArray = Object.entries(loadsToToggle);

  // Loop through the array of key-value pairs
  for (let [key, value] of loadsArray) {
    // If value is set to true, call the activate endpoint with the load ID
    if (value === true) {
      try {
        let activateResponse = await axios({
          url: process.env.REACT_APP_BO_ACTIVATE_LOAD_URL,
          params: { loadId: key },
          method: "post",
        });
        toast.success(activateResponse.data, { progress: 0.99 });
      } catch (error) {
        toast.error("Load " + key + " failed to activate with error=" + error, { progress: 0.99 });
      }
    }
    else {
      // If value is set to false, call the deactivate endpoint with the load ID
      try {
        let deactivateResponse = await axios({
          url: process.env.REACT_APP_BO_DEACTIVATE_LOAD_URL,
          params: { loadId: key },
          method: "post",
        });
        toast.success(deactivateResponse.data, { progress: 0.99 });
      } catch (error) {
        toast.error("Deactivation of load " + key + " failed with error=" + error, { progress: 0.99 });
      }
    }
  }

  // Now that all loads have been toggled, call the get loads endpoint to refresh the list
  dispatch(getLoads());
};

export const toggleInCommLoads = (loadsToToggle)=> async (dispatch) => {

  // Convert loadsToToggle to an array of key-value pairs
  // loadsToToggle contains the list of loads that the user has changed
  const loadsArray = Object.entries(loadsToToggle);

  // Loop through the array of key-value pairs
  for (let [key, value] of loadsArray) {
    // If value is set to true, call the activate endpoint with the load ID
    if (value === true) {
      try {
        let activateResponse = await axios({
          url: process.env.REACT_APP_BO_ACTIVATE_INCOMM_LOAD_URL,
          params: { loadId: key },
          method: "post",
        });
        toast.success(activateResponse.data, { progress: 0.99 });
      } catch (error) {
        toast.error("Load " + key + " failed to activate with error=" + error, { progress: 0.99 });
      }
    }
    else {
      // If value is set to false, call the deactivate endpoint with the load ID
      try {
        let deactivateResponse = await axios({
          url: process.env.REACT_APP_BO_DEACTIVATE_INCOMM_LOAD_URL,
          params: { loadId: key },
          method: "post",
        });
        toast.success(deactivateResponse.data, { progress: 0.99 });
      } catch (error) {
        toast.error("Deactivation of load " + key + " failed with error=" + error, { progress: 0.99 });
      }
    }
  }

  // Now that all loads have been toggled, call the get loads endpoint to refresh the list
  dispatch(getInCommLoads());
};

// Calls the back end to retrieve the property list
export const getPropertyList = () => async (dispatch) => {
  try {
    dispatch({
      type: boConstants.BACK_OFFICE_PROPERTY_LIST_REQUEST,
    });

    let propertyResponse = await axios({
      url: process.env.REACT_APP_BO_GET_PROPERTY_LIST_URL,
      method: "GET",
      responseType: "json",
    });

    dispatch({
      type: boConstants.BACK_OFFICE_PROPERTY_LIST_SUCCESS,
      payload: propertyResponse.data,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_PROPERTY_LIST_FAIL,
      error: message,
    });
  }
};

// Calls the back end refresh catalog endpoint
export const refreshCatalog = () => async (dispatch) => {
  try {
    // First set the state to requesting the catalog
    dispatch({
      type: boConstants.BACK_OFFICE_CATALOG_REQUEST,
    });

    // Dispatch the request to refresh the catalog and wait for a response
    let catalogResponse = await axios({
      url: process.env.REACT_APP_BO_REFRESH_CATALOG_URL,
      method: "post",
    });

    // If the refresh was successful, set the state to success
    dispatch({
      type: boConstants.BACK_OFFICE_CATALOG_SUCCESS,
      payload: catalogResponse.data,
    });

    toast.success("Catalog refresh successful", { progress: 0.99 });

    // Now refresh the brand catalog list
    dispatch(getBrandCatalog());

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    toast.error("Catalog refresh failed with error '" + message + "'", { progress: 0.99 });

    // If the refresh fails, set the state to fail
    dispatch({
      type: boConstants.BACK_OFFICE_CATALOG_FAIL,
      error: message,
    });
  }
};

export const resetBackOffice = () => async (dispatch) => {
  // Set the state to reset request
  dispatch({
    type: boConstants.BACK_OFFICE_RESET_REQUEST,
  });
};


// Calls the back end to retrieve the list of failed offers
export const getIncompleteOffers = (pageNumber = 0,
                                    pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE,
                                    showTestOffers) => async (dispatch) => {
  try {
    dispatch({
      type: boConstants.BACK_OFFICE_GET_INCOMPLETE_OFFERS_REQUEST,
    });

    let serverResponse = await axios({
      url: process.env.REACT_APP_BO_GET_INCOMPLETE_OFFERS_URL,
      params: {
        showTestOffers: showTestOffers,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
      method: "GET",
      responseType: "json",
    });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_INCOMPLETE_OFFERS_SUCCESS,
      payload: serverResponse.data,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_GET_INCOMPLETE_OFFERS_FAIL,
      error: message,
    });
  }
};

export const getLoads = (pageNumber = 0, pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => async (dispatch) => {
  try {
    dispatch({
      type: boConstants.BACK_OFFICE_GET_LOADS_REQUEST,
    });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_GET_LOADS_URL,
      method: "POST",
      data:  {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_LOADS_SUCCESS,
      payload: serverResponse.data,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_GET_LOADS_FAIL,
      error: message,
    });

  }
};


export const getInCommLoads = (pageNumber = 0, pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => async (dispatch) => {
  try {
    dispatch({
      type: boConstants.BACK_OFFICE_GET_INCOMM_LOADS_REQUEST,
    });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_GET_INCOMM_LOADS_URL,
      method: "POST",
      data:  {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_INCOMM_LOADS_SUCCESS,
      payload: serverResponse.data,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_GET_INCOMM_LOADS_FAIL,
      error: message,
    });

  }
};

export const getPlayerOffers = (pageNumber = 0,
                                pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE,
                                playerIdOrEmail) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_OFFERS_REQUEST,
    });


    if (!playerIdOrEmail || typeof playerIdOrEmail !== "string") {
      const err = "playerIdOrEmail is required";
      dispatch({ type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_FAIL, error: err });
      return;
    }

    const trimmedPlayerIdOrEmail = playerIdOrEmail.trim();
    if (!trimmedPlayerIdOrEmail) {
      const err = "playerIdOrEmail is empty";
      dispatch({ type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_FAIL, error: err });
      return;
    }

    // Determine if the input is an email or player ID
    let bodyData = {};
    if (isEmail(trimmedPlayerIdOrEmail)) {
      bodyData = { email: trimmedPlayerIdOrEmail };
    } else {
      bodyData = { guestId: trimmedPlayerIdOrEmail };
    }

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_GET_PLAYER_OFFERS_URL,
      method: "POST",
      data: bodyData,
      params:  {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_OFFERS_SUCCESS,
      payload: serverResponse.data.giftCardOffers,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    toast.error("Failed to retrieve player offers with error '" + message + "'", { progress: 0.99 });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_OFFERS_FAIL,
      error: message,
    });

  }
};



export const getPlayerLegacyOffers = (pageNumber = 0,
                                pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE,
                                playerIdOrEmail) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_LEGACY_OFFERS_REQUEST,
    });


    if (!playerIdOrEmail || typeof playerIdOrEmail !== "string") {
      const err = "playerIdOrEmail is required";
      dispatch({ type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_FAIL, error: err });
      return;
    }

    const trimmedPlayerIdOrEmail = playerIdOrEmail.trim();
    if (!trimmedPlayerIdOrEmail) {
      const err = "playerIdOrEmail is empty";
      dispatch({ type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_FAIL, error: err });
      return;
    }

    // Determine if the input is an email or player ID
    let bodyData = {};
    if (isEmail(trimmedPlayerIdOrEmail)) {
      bodyData = { email: trimmedPlayerIdOrEmail };
    } else {
      bodyData = { guestId: trimmedPlayerIdOrEmail };
    }

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_GET_PLAYER_LEGACY_OFFERS_URL,
      method: "POST",
      data: bodyData,
      params:  {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_LEGACY_OFFERS_SUCCESS,
      payload: serverResponse.data.legacyGiftCardOffers,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    toast.error("Failed to retrieve player offers with error '" + message + "'", { progress: 0.99 });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_LEGACY_OFFERS_FAIL,
      error: message,
    });

  }
};




export const forceClaim = (awardId,
                           playerId,
                           pageNumber = 0,
                           pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => async (dispatch) => {
  try {
    dispatch({
      type: boConstants.BACK_OFFICE_FORCE_CLAIM_REQUEST,
    });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_FORCE_CLAIM_URL,
      method: "POST",
      params:  {
        awardId: awardId,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_FORCE_CLAIM_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success(serverResponse.data, { progress: 0.99 });

    // Now that the offer has been forced, call the get offers endpoint to refresh the list
    dispatch(getPlayerOffers(pageNumber, pageSize, playerId));

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    toast.error("Force claim failed with error '" + message + "'", { progress: 0.99 });

    dispatch({
      type: boConstants.BACK_OFFICE_FORCE_CLAIM_FAIL,
      error: message,
    });

  }
};

// Fetches the brand catalog from the server in a paginated manner.
// Defaults to page 0 and page size 50 if not specified.
export const getBrandCatalog = (pageNumber = 0,
                                pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_GET_BRAND_CATALOG_REQUEST,
    });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_GET_BRAND_CATALOG_URL,
      method: "GET",
      params:  {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_BRAND_CATALOG_SUCCESS,
      payload: serverResponse.data,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_GET_BRAND_CATALOG_FAIL,
      error: message,
    });

  }
};


export const cancelOffer = (awardId,
                           showTestOffers,
                           pageNumber = 0,
                           pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_CANCEL_OFFER_REQUEST,
    });


    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_CANCEL_OFFER_URL,
      method: "POST",
      params:  {
        awardId: awardId,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_CANCEL_OFFER_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success(serverResponse.data, { progress: 0.99 });

    // Now that the offer has been canceled, call the get problem offers endpoint to refresh the list
    dispatch(getIncompleteOffers(pageNumber, pageSize, showTestOffers));

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    // If the message contains the words "Could not lock offer", display a different message
    if (message.includes("Could not lock offer")) {
      toast.error("This offer is currently locked by another process, likely because the offer is " +
        "being retried. Wait a few minutes and try again.", { progress: 0.99 });
    }
    else {
      toast.error("Cancel offer failed with error '" + message + "'", { progress: 0.99 });
    }

    dispatch({
      type: boConstants.BACK_OFFICE_CANCEL_OFFER_FAIL,
      error: message,
    });

  }
};


export const retryOffer = (awardId,
                            showTestOffers,
                            pageNumber = 0,
                            pageSize = process.env.REACT_APP_DEFAULT_PAGE_SIZE) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_RETRY_OFFER_REQUEST,
    });


    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_RETRY_OFFER_URL,
      method: "POST",
      params:  {
        awardId: awardId,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_RETRY_OFFER_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success(serverResponse.data, { progress: 0.99 });

    // Now that the offer has been canceled, call the get problem offers endpoint to refresh the list
    dispatch(getIncompleteOffers(pageNumber, pageSize, showTestOffers));

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    // If the message contains the words "Could not lock offer", display a different message
    if (message.includes("Could not lock offer")) {
      toast.error("This offer is currently locked by another process." +
        "Wait a few minutes and try again.", { progress: 0.99 });
    }
    else {
      toast.error("Retry offer failed with error '" + message + "'", { progress: 0.99 });
    }

    dispatch({
      type: boConstants.BACK_OFFICE_RETRY_OFFER_FAIL,
      error: message,
    });

  }
};

export const getPlayerProfile = (playerIdOrEmail) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_REQUEST,
    });

    if (!playerIdOrEmail || typeof playerIdOrEmail !== "string") {
      const err = "playerIdOrEmail is required";
      dispatch({ type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_FAIL, error: err });
      return;
    }

    const trimmedPlayerIdOrEmail = playerIdOrEmail.trim();
    if (!trimmedPlayerIdOrEmail) {
      const err = "playerIdOrEmail is empty";
      dispatch({ type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_FAIL, error: err });
      return;
    }

    // Determine if the input is an email or player ID
    let bodyData = {};
    if (isEmail(trimmedPlayerIdOrEmail)) {
      bodyData = { email: trimmedPlayerIdOrEmail };
    } else {
      bodyData = { guestId: trimmedPlayerIdOrEmail };
    }

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_GET_PLAYER_PROFILE_URL,
      method: "POST",
      data: bodyData,
    });

    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_SUCCESS,
      payload: serverResponse.data,
    });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_GET_PLAYER_PROFILE_FAIL,
      error: message,
    });

  }
};

export const reactivatePlayer = (playerId, email) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_REACTIVATE_PLAYER_REQUEST,
    });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_REACTIVATE_PLAYER_URL,
      method: "POST",
      data:  {
        guestId: playerId,
        email: email
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_REACTIVATE_PLAYER_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success("Player " + playerId
      + " successfully reactivated.", { progress: 0.99 });

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    toast.error("Failed to reactivate player " + playerId
      + " with error '" + message + "'", { progress: 0.99 });

    dispatch({
      type: boConstants.BACK_OFFICE_REACTIVATE_PLAYER_FAIL,
      error: message,
    });

  }
};

export const unlockPlayer = (playerId, email) => async (dispatch) => {
  try {
    dispatch({ type: boConstants.BACK_OFFICE_UNLOCK_PLAYER_REQUEST });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_UNLOCK_PLAYER_URL,
      method: "POST",
      data: {
        guestId: playerId,
        email: email
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_UNLOCK_PLAYER_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success("Player " + playerId + " successfully unlocked.", { progress: 0.99 });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    toast.error("Failed to unlock player " + playerId + " with error '" + message + "'", { progress: 0.99 });

    dispatch({
      type: boConstants.BACK_OFFICE_UNLOCK_PLAYER_FAIL,
      error: message,
    });
  }
};

export const resetPlayerPassword = (email) => async (dispatch) => {
  // show a processing/loading toast because reset can take a moment
  const toastId = toast.loading("Resetting password. Please wait...");
  try {
    dispatch({ type: boConstants.BACK_OFFICE_RESET_PASSWORD_REQUEST });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_RESET_USER_PASSWORD_URL,
      method: "POST",
      data: { email: email },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_RESET_PASSWORD_SUCCESS,
      payload: serverResponse.data,
    });

    // dismiss loading and show success
    toast.dismiss(toastId);
    toast.success("Password reset initiated for player " + email + ".", { progress: 0.99 });
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    // dismiss loading and show error
    toast.dismiss(toastId);
    toast.error(
      "Failed to reset password for player " + email + " with error '" + message + "'",
      { progress: 0.99 }
    );

    dispatch({
      type: boConstants.BACK_OFFICE_RESET_PASSWORD_FAIL,
      error: message,
    });
  }
};

// Resend verification email for a user (sends { email } in request body).
export const resendUserVerification = (email) => async (dispatch) => {
  const toastId = toast.loading("Resending verification email. Please wait...");
  try {
    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_RESEND_USER_VERIFICATION_URL,
      method: "POST",
      data: { email: email },
    });

    // dismiss loading and show success
    toast.dismiss(toastId);
    toast.success("Verification email resent to " + email + ".", { progress: 0.99 });

    // optionally return server response for caller
    return serverResponse.data;
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    // dismiss loading and show error
    toast.dismiss(toastId);
    toast.error("Failed to resend verification to " + email + ": " + message, { progress: 0.99 });

    // rethrow so caller can react if needed
    throw error;
  }
};

export const setBirthday = (playerId, birthday) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_SET_BIRTHDAY_REQUEST,
    });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_SET_BIRTHDAY_URL,
      method: "POST",
      data:  {
        playerId: playerId,
        birthday: birthday,
      },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_SET_BIRTHDAY_SUCCESS,
      payload: serverResponse.data,
    });

    // show success toast for the update
    toast.success("Birthday updated.", { progress: 0.99 });

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_SET_BIRTHDAY_FAIL,
      error: message,
    });

  }
};

// Adds a new offer. Uses a placeholder endpoint (REPLACE with real endpoint env var)
export const addOffer = (offerData) => async (dispatch) => {
  try {
    dispatch({ type: boConstants.BACK_OFFICE_ADD_OFFER_REQUEST });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_ADD_OFFER_URL, // placeholder env var
      method: "POST",
      data: offerData,
    });

    dispatch({ type: boConstants.BACK_OFFICE_ADD_OFFER_SUCCESS, payload: serverResponse.data });

    toast.success(serverResponse.data.responseMessage, {
      progress: 0.99,
      style: {
        whiteSpace: 'pre-line'
      }
    });

    // Return server response for callers if needed
    return serverResponse.data;
  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.response ||
      error.message ||
      error.toString();

    dispatch({ type: boConstants.BACK_OFFICE_ADD_OFFER_FAIL, error: message });
    toast.error("Failed to add offer: " + message, { progress: 0.99 });
    throw error;
  }
};

export const setZipcode = (playerId, zipcode) => async (dispatch) => {

  try {
    dispatch({
      type: boConstants.BACK_OFFICE_SET_ZIPCODE_REQUEST,
    });

    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_UPDATE_USER_PROFILE_URL,
      method: "POST",
      data: { playerId: playerId, zipCode: zipcode },
    });

    dispatch({
      type: boConstants.BACK_OFFICE_SET_ZIPCODE_SUCCESS,
      payload: serverResponse.data,
    });

    // show success toast for the update
    toast.success("Zip code updated.", { progress: 0.99 });

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_SET_ZIPCODE_FAIL,
      error: message,
    });

  }
};

// new actions to persist profile fields to server
export const setEmail = (guestId, email) => async (dispatch) => {
  // show a processing/loading toast because this endpoint can take longer
  const toastId = toast.loading("Updating email. Please wait...");

  try {
    dispatch({ type: boConstants.BACK_OFFICE_SET_EMAIL_REQUEST });
    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_SET_EMAIL_URL,
      method: "POST",
      data: { guestId: guestId, email: email },
    });
    dispatch({
      type: boConstants.BACK_OFFICE_SET_EMAIL_SUCCESS,
      payload: serverResponse.data,
    });

    // dismiss loading and show success
    toast.dismiss(toastId);
    toast.success("Email updated.", { progress: 0.99 });

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();

    // dismiss loading and show error
    toast.dismiss(toastId);
    toast.error("Failed to update email: " + message, { progress: 0.99 });

    dispatch({
      type: boConstants.BACK_OFFICE_SET_EMAIL_FAIL,
      error: message,
    });
  }
};

export const setFirstName = (playerId, firstName) => async (dispatch) => {
  try {
    dispatch({ type: boConstants.BACK_OFFICE_SET_FIRSTNAME_REQUEST });
    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_UPDATE_USER_PROFILE_URL,
      method: "POST",
      // send update in request body. backend agreed to a unified endpoint that reads the body.
      data: { playerId: playerId, firstName: firstName },
    });
    dispatch({
      type: boConstants.BACK_OFFICE_SET_FIRSTNAME_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success("First name updated.", { progress: 0.99 });

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();
    dispatch({
      type: boConstants.BACK_OFFICE_SET_FIRSTNAME_FAIL,
      error: message,
    });
  }
};

export const setLastName = (playerId, lastName) => async (dispatch) => {
  try {
    dispatch({ type: boConstants.BACK_OFFICE_SET_LASTNAME_REQUEST });
    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_UPDATE_USER_PROFILE_URL,
      method: "POST",
      data: { playerId: playerId, lastName: lastName },
    });
    dispatch({
      type: boConstants.BACK_OFFICE_SET_LASTNAME_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success("Last name updated.", { progress: 0.99 });

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();
    dispatch({
      type: boConstants.BACK_OFFICE_SET_LASTNAME_FAIL,
      error: message,
    });
  }
};

export const setGuestId = (username, guestId) => async (dispatch) => {
  try {
    dispatch({ type: boConstants.BACK_OFFICE_SET_GUESTID_REQUEST });
    const serverResponse = await axios({
      url: process.env.REACT_APP_BO_SET_GUESTID_URL,
      method: "POST",
      data: { email: username, guestId: guestId },
    });
    dispatch({
      type: boConstants.BACK_OFFICE_SET_GUESTID_SUCCESS,
      payload: serverResponse.data,
    });

    toast.success("Rewards ID updated.", { progress: 0.99 });

  } catch (error) {
    const message =
      (error.response && error.response.data) ||
      error.message ||
      error.toString();
    dispatch({
      type: boConstants.BACK_OFFICE_SET_GUESTID_FAIL,
      error: message,
    });
  }
};

export const clearPlayerProfile = () => ({
  type: boConstants.BACK_OFFICE_CLEAR_PLAYER_PROFILE,
});


// Calls the back end to retrieve the excel error file
export const downloadExcelFile = (fileName) => async (dispatch) => {
  try {
    dispatch({
      type: boConstants.BACK_OFFICE_DOWNLOAD_EXCEL_FILE_REQUEST,
    });

    let fileResponse = await axios({
      params: {
        fileName: fileName
      },
      url: process.env.REACT_APP_BO_DOWNLOAD_EXCEL_FILE_URL,
      method: "GET",
      responseType: "blob",
    });

    //console.log("FileResponse = ", fileResponse);

    dispatch({
      type: boConstants.BACK_OFFICE_DOWNLOAD_EXCEL_FILE_SUCCESS,
    });
    //console.log("Dispatch success");

    //console.log("Create Window URL oject");
    const fileURL = window.URL.createObjectURL(new Blob([fileResponse.data]));
    //console.log("fileURL: ", {fileURL});

    // Create a temporary <a> element for the download
    const link = document.createElement("a");
    link.href = fileURL;

    const strippedFileName = fileName.split(/(\\|\/)/g).pop();
    //console.log("Stripped file name: ", {strippedFileName});

    // Set the downloaded file name (optional but useful)
    link.setAttribute("download", strippedFileName);

    // Append the link to the document
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    //console.log("Clicking link");
    link.click();

    // Clean up the created link and URL object to avoid memory leaks
    //console.log("Remove document body link");
    document.body.removeChild(link);
    //console.log("Revoke window URL object");
    window.URL.revokeObjectURL(fileURL);

  } catch (error) {
    const message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString();

    dispatch({
      type: boConstants.BACK_OFFICE_DOWNLOAD_EXCEL_FILE_FAIL,
      error: message,
    });
    //console.log("Dispatch failed");
  }
};